"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _FormTitleWrapper = require("./FormTitleWrapper");
Object.keys(_FormTitleWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _FormTitleWrapper[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _FormTitleWrapper[key];
    }
  });
});